import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';
import services from '@/services/index';

export type SlackResponse = {
  is_duplicated: boolean;
  workspace_name: string;
  user_name: string;
  team_id: string;
  team_name: string;
};

const SlackRedirect = () => {
  const [, setRedirect] = useCrossWindowState<SlackResponse | null>(
    'slack-redirect',
    null,
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const workspaceAlias = state;
      const asyncUpdateHandler = async () => {
        const data: SlackResponse = await services.slack.createSlackInfo(
          code,
          workspaceAlias,
        );

        if (data) {
          if (data.is_duplicated) {
            navigate(
              `/slack-fail?workspace_name=${data.workspace_name}&user_name=${data.user_name}`,
              {
                replace: true,
              },
            );
          } else {
            setRedirect(data);
            window.close();
          }
        } else {
          navigate('/500', { replace: true });
        }
      };
      asyncUpdateHandler();
    }
  }, [setRedirect, navigate, searchParams]);

  return <LoadingLayout>Connecting this slack channel...</LoadingLayout>;
};

export default SlackRedirect;
